import { HttpErrorResponse } from "@angular/common/http";
import { LearnersReportDto, ReportsChart, ReportDetailsDto, UpdateReportsFilter } from "src/app/_models/Reports";

export interface LearnerReportState {
  reportTypes: string[];
  reportTypesLoader: boolean;
  reportTypesError: HttpErrorResponse;

  updateReportFilter: boolean;
  updateReportFilterLoader: boolean;
  updateReportFilterError: HttpErrorResponse;

  getReportsFilter: UpdateReportsFilter;
  getReportsFilterLoader: boolean;
  getReportsFilterError: HttpErrorResponse;

  generateReportResult: boolean;
  generateReportLoader: boolean;
  generateReportError: HttpErrorResponse;

  reportsTableResult: LearnersReportDto[];
  reportsTableLoader: boolean;
  reportsTableError: HttpErrorResponse;

  reportDetails: ReportDetailsDto;
  reportDetailsLoader: boolean;
  reportDetailsError: HttpErrorResponse;

  updateTableReportResult: boolean;
  updateTableReportLoader: boolean;
  updateTableReportError: HttpErrorResponse;

  learnerReportListLength: number; 
  learnerReportListLengthLoader: boolean;
  learnerReportListLengthError: HttpErrorResponse;

  reportsChart: ReportsChart[];
  reportsChartLoader: boolean;
  reportsChartError: HttpErrorResponse;

  resetLearnerTable: boolean;
  resetLearnerTableLoader: boolean;
  resetLearnerTableError: HttpErrorResponse;

  exportReportsTable: LearnersReportDto[];
  exportReportsTableLoader: boolean;
  exportReportsTableError: HttpErrorResponse;
}

export const initialLearnerReportState: LearnerReportState = {
  reportTypes: [],
  reportTypesLoader: false,
  reportTypesError: null,

  updateReportFilter: null,
  updateReportFilterLoader: false,
  updateReportFilterError: null,

  getReportsFilter: null,
  getReportsFilterLoader: false,
  getReportsFilterError: null,

  generateReportResult: null,
  generateReportLoader: false,
  generateReportError: null,

  reportsTableResult: null,
  reportsTableLoader: false,
  reportsTableError: null,

  reportDetails: null,
  reportDetailsLoader: false,
  reportDetailsError: null,

  updateTableReportResult: null,
  updateTableReportLoader: false,
  updateTableReportError: null,

  learnerReportListLength: null,
  learnerReportListLengthLoader: false,
  learnerReportListLengthError: null,

  reportsChart: null,
  reportsChartLoader: false,
  reportsChartError: null,

  resetLearnerTable: null,
  resetLearnerTableLoader: false,
  resetLearnerTableError: null,

  exportReportsTable: null,
  exportReportsTableLoader: false,
  exportReportsTableError: null,
}